import { combineReducers } from '../lib/imports';

const howToGuide = {
  1: {
    id: 'howto-step-1',
    title: 'Scan for Tims Rewards',
    filename: 'howToPick',
    variant: 1,
    assetSize: '95',
  },
  2: {
    id: 'howto-step-2',
    title: 'Purchase a pack of digital hockey cards',
    filename: 'howToSubmit',
    variant: 0,
    assetSize: '50',
  },
  3: {
    id: 'howto-step-3',
    title: 'Earn card pack unwraps to win!',
    filename: 'howToWin',
    variant: 1,
    isLast: true,
    assetSize: '95',
  },
};

const byId = (state = howToGuide) => state;

const allIds = (state = Object.keys(howToGuide)) => state;

export default combineReducers({
  byId,
  allIds,
});
